var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.redirecting)?_c('div',{attrs:{"id":"loading-padding"}},[_c('h1',[_vm._v("Cargando... Espera un momento por favor")]),_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }